import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const LifeInsuranceEmailThread = Loadable(
  lazy(() =>
    import("./LifeInsuranceEmailThread").then(({ LifeInsuranceEmailThread }) => ({
      default: LifeInsuranceEmailThread,
    }))
  )
);

export const LifeInsuranceEmailThreadRoutes = [
  {
    path: "/life-insurance-policy/:customerId/email-thread/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.LIFE_AND_FINCANCIAL]}>
        <LifeInsuranceEmailThread />
      </AuthorizedRoute>
    ),
  },
];
